import { render } from "./Index.vue?vue&type=template&id=b334d1a8"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/teacher/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b334d1a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b334d1a8', __exports__)) {
    console.log('reload')
    api.reload('b334d1a8', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=b334d1a8", () => {
    console.log('re-render')
    api.rerender('b334d1a8', render)
  })

}


export default __exports__